"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
//
// styles
//
const StyledInput_1 = require("./StyledInput");
const StyledIcon_1 = require("./StyledIcon");
const StyledSearchBar_1 = require("./StyledSearchBar");
const SearchBar = (props) => {
    return (react_1.default.createElement(StyledSearchBar_1.StyledSearchBar, null,
        react_1.default.createElement(StyledIcon_1.StyledIcon, { className: 'fe fe-search' }),
        react_1.default.createElement(StyledInput_1.StyledInput, { className: 'form-control search-bar', onChange: props.onSearch, placeholder: 'Search', type: 'text' })));
};
exports.default = SearchBar;
